import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@material-ui/core";
import { FormikHandlers } from "formik";
import React, { createRef } from "react";

import EditAddress from "../EditAddress";

interface IEditAddressDialogProps {
  show: boolean;
  accountId: string;
  addressId: string;
  onClose: () => void;
}

function EditAddressDialog({
  accountId,
  addressId,
  show,
  onClose,
}: IEditAddressDialogProps) {
  const ref = createRef<FormikHandlers>();

  function handleChildFormSubmit() {
    // This ref holds a reference of the Address form which get
    // renders as a child. If it holds a valid Formik form instance, then
    // trigger it's handleSubmit.

    if (ref && ref.current && ref.current.handleSubmit) {
      ref.current.handleSubmit();
    }
  }

  return (
    <Dialog open={show} onClose={onClose}>
      <DialogTitle>Edit address</DialogTitle>

      <Divider />

      <DialogContent>
        <EditAddress
          ref={ref}
          accountId={accountId}
          addressId={addressId}
          closeDialog={() => onClose()}
        />
      </DialogContent>

      <Divider />

      <DialogActions>
        <Button color="secondary" variant="contained" onClick={() => onClose()}>
          Close
        </Button>

        <Button
          color="primary"
          variant="contained"
          onClick={handleChildFormSubmit}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditAddressDialog;
